import { useEffect, useState } from "react";
import EntityPage from "@/components/EntityPage";
import { api, euro, STATI_FLOTTA, TIPI_BICI } from "@/lib/api";

const STILE = { disponibile: "bg-emerald-50 text-emerald-700 ring-emerald-200", manutenzione: "bg-amber-50 text-amber-800 ring-amber-200", fuori_servizio: "bg-slate-100 text-slate-500 ring-slate-200" };

const fields = [
  { name: "codice", label: "Codice flotta (es. N01)" },
  { name: "marca", label: "Marca", required: true },
  { name: "modello", label: "Modello" },
  { name: "tipo", label: "Tipo", type: "select", options: TIPI_BICI },
  { name: "taglia", label: "Taglia" },
  { name: "telaio", label: "N° telaio" },
  { name: "tariffa_ora", label: "Tariffa oraria (€)", type: "number", step: "0.01" },
  { name: "tariffa_mezza", label: "Tariffa mezza giornata (€)", type: "number", step: "0.01" },
  { name: "tariffa_giorno", label: "Tariffa giornaliera (€)", type: "number", step: "0.01" },
  { name: "tariffa_weekend", label: "Tariffa weekend, sabato–domenica (€)", type: "number", step: "0.01" },
  { name: "cauzione", label: "Cauzione (€)", type: "number", step: "0.01" },
  { name: "stato_flotta", label: "Stato", type: "select", default: "disponibile", options: STATI_FLOTTA },
  { name: "note", label: "Note", type: "textarea" },
];

export default function Flotta() {
  const [fuori, setFuori] = useState(new Set());
  useEffect(() => {
    api.get("/noleggi", { params: { stato: "in_corso" } }).then((r) => setFuori(new Set(r.data.flatMap((n) => n.bici_ids))));
  }, []);
  const columns = [
    { key: "codice", label: "Codice", render: (b) => <span className="font-mono text-xs font-bold text-orange-600">{b.codice || "—"}</span> },
    { key: "marca", label: "Bici", render: (b) => <span className="font-semibold text-slate-900">{b.marca} {b.modello}</span> },
    { key: "tipo", label: "Tipo" },
    { key: "taglia", label: "Taglia" },
    { key: "tariffa_ora", label: "€/ora", render: (b) => <span className="font-mono">{euro(b.tariffa_ora)}</span> },
    { key: "tariffa_mezza", label: "€/½ giorno", render: (b) => <span className="font-mono">{euro(b.tariffa_mezza)}</span> },
    { key: "tariffa_giorno", label: "€/giorno", render: (b) => <span className="font-mono">{euro(b.tariffa_giorno)}</span> },
    { key: "tariffa_weekend", label: "€/weekend", render: (b) => <span className="font-mono">{euro(b.tariffa_weekend)}</span> },
    { key: "stato_flotta", label: "Stato", render: (b) => fuori.has(b.id)
      ? <span className="rounded-sm bg-sky-50 px-2 py-0.5 text-xs font-semibold text-sky-700 ring-1 ring-sky-200" data-testid={`flotta-stato-${b.id}`}>Noleggiata ora</span>
      : <span className={`rounded-sm px-2 py-0.5 text-xs font-semibold ring-1 ${STILE[b.stato_flotta] || STILE.disponibile}`} data-testid={`flotta-stato-${b.id}`}>{STATI_FLOTTA.find((s) => s.value === b.stato_flotta)?.label || "Disponibile"}</span> },
  ];
  return (
    <EntityPage overline="Noleggio" title="Flotta bici a noleggio" endpoint="bici_noleggio" prefix="flotta" singular="bici a noleggio"
      newLabel="Nuova bici a noleggio" fields={fields} columns={columns} />
  );
}
